import React, { useState, useEffect, useCallback } from 'react';
import { API, C, authHeaders, when, btn, btnMain, inp } from './modApi';

const KINDS = [
  ['text', 'Short text'],
  ['long', 'Long text'],
  ['yesno', 'Yes / No'],
  ['choice', 'Pick one'],
  ['multi', 'Pick several'],
  ['time', 'Time / hours'],
  ['mega', 'Which Mega Mod'],
];

function ReplyForm({ rcId, onDone, onBack }) {
  const [d, setD] = useState(null);
  const [ans, setAns] = useState({});
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(function () {
    fetch(API + '/rollcalls/' + rcId + '/', { headers: authHeaders() })
      .then(function (r) { return r.json(); })
      .then(function (j) { setD(j); if (j.my_reply) setAns(j.my_reply); })
      .catch(function () {});
  }, [rcId]);

  if (!d) return <p style={{ color: C.muted, textAlign: 'center', padding: '2rem 0' }}>Loading...</p>;
  if (d.error) return <p style={{ color: C.danger, textAlign: 'center', padding: '2rem 0' }}>{d.error}</p>;

  const set = function (qid, v) { setAns({ ...ans, [String(qid)]: v }); };
  const toggleMulti = function (qid, opt) {
    const cur = ans[String(qid)] || [];
    const list = Array.isArray(cur) ? cur : [];
    set(qid, list.indexOf(opt) >= 0 ? list.filter(function (x) { return x !== opt; }) : list.concat([opt]));
  };

  const submit = async function () {
    setBusy(true); setMsg('');
    try {
      const res = await fetch(API + '/rollcalls/' + rcId + '/reply/', {
        method: 'POST', headers: authHeaders(), body: JSON.stringify({ answers: ans }) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      setMsg('Thanks - your reply is in.');
      setTimeout(onDone, 1200);
    } catch (e) { setMsg(e.message); }
    setBusy(false);
  };

  const already = !d.can_reply && d.my_reply;

  return (
    <div>
      <button onClick={onBack} style={{ ...btn, marginBottom: 10 }}>Back</button>
      <div style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 10, padding: 14 }}>
        <p style={{ margin: '0 0 3px', fontSize: 15, fontWeight: 700 }}>{d.title}</p>
        {d.intro ? <p style={{ margin: '0 0 11px', fontSize: 12.5, color: C.muted, lineHeight: 1.6 }}>{d.intro}</p> : null}
        {already ? <p style={{ fontSize: 12.5, color: C.primary, fontWeight: 600, margin: '0 0 11px' }}>You already replied to this one.</p> : null}

        {d.questions.map(function (q, i) {
          const val = ans[String(q.id)];
          return (
            <div key={q.id} style={{ marginBottom: 14 }}>
              <p style={{ margin: '0 0 5px', fontSize: 13, fontWeight: 600 }}>
                {i + 1}. {q.text}{q.required ? <span style={{ color: C.danger }}> *</span> : null}
              </p>
              {q.hint ? <p style={{ margin: '0 0 5px', fontSize: 11, color: C.muted }}>{q.hint}</p> : null}

              {q.kind === 'long' ? (
                <textarea value={val || ''} disabled={already} rows={3}
                  onChange={function (e) { set(q.id, e.target.value); }}
                  style={{ ...inp, resize: 'vertical' }} />
              ) : q.kind === 'yesno' ? (
                <div style={{ display: 'flex', gap: 7 }}>
                  {['Yes', 'No'].map(function (o) {
                    const on = val === o;
                    return <button key={o} disabled={already} onClick={function () { set(q.id, o); }}
                      style={{ ...btn, background: on ? C.primaryBg : '#fff', color: on ? C.primary : C.muted,
                               borderColor: on ? C.primary : C.border, fontWeight: on ? 700 : 400 }}>{o}</button>;
                  })}
                </div>
              ) : q.kind === 'choice' ? (
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  {(q.options || []).map(function (o) {
                    const on = val === o;
                    return <button key={o} disabled={already} onClick={function () { set(q.id, o); }}
                      style={{ ...btn, background: on ? C.primaryBg : '#fff', color: on ? C.primary : C.muted,
                               borderColor: on ? C.primary : C.border, fontWeight: on ? 700 : 400 }}>{o}</button>;
                  })}
                </div>
              ) : q.kind === 'multi' ? (
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  {(q.options || []).map(function (o) {
                    const list = Array.isArray(val) ? val : [];
                    const on = list.indexOf(o) >= 0;
                    return <button key={o} disabled={already} onClick={function () { toggleMulti(q.id, o); }}
                      style={{ ...btn, background: on ? C.primaryBg : '#fff', color: on ? C.primary : C.muted,
                               borderColor: on ? C.primary : C.border, fontWeight: on ? 700 : 400 }}>{on ? '+ ' : ''}{o}</button>;
                  })}
                </div>
              ) : q.kind === 'mega' ? (
                <select value={val || ''} disabled={already} onChange={function (e) { set(q.id, e.target.value); }} style={inp}>
                  <option value="">Choose...</option>
                  {(d.mega_mods || []).map(function (m) { return <option key={m} value={m}>{m}</option>; })}
                </select>
              ) : (
                <input value={val || ''} disabled={already} onChange={function (e) { set(q.id, e.target.value); }}
                  placeholder={q.kind === 'time' ? 'e.g. 6pm - 11pm' : ''} style={inp} />
              )}
            </div>
          );
        })}

        {msg ? <p style={{ fontSize: 12.5, margin: '0 0 9px', color: msg.indexOf('Thanks') === 0 ? C.primary : C.danger }}>{msg}</p> : null}
        {!already ? <button onClick={submit} disabled={busy} style={btnMain}>{busy ? 'Sending...' : 'Submit reply'}</button> : null}
      </div>
    </div>
  );
}

function Report({ rcId, onBack }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(function () {
    fetch(API + '/rollcalls/' + rcId + '/report/', { headers: authHeaders() })
      .then(function (r) { return r.json(); }).then(setD).catch(function () {});
  }, [rcId]);
  useEffect(function () { load(); }, [load]);

  if (!d) return <p style={{ color: C.muted, textAlign: 'center', padding: '2rem 0' }}>Loading...</p>;
  if (d.error) return <p style={{ color: C.danger, textAlign: 'center', padding: '2rem 0' }}>{d.error}</p>;

  const remind = async function () {
    if (!window.confirm('Remind the ' + d.missing_count + ' who have not replied?')) return;
    setBusy(true);
    try {
      const res = await fetch(API + '/rollcalls/' + rcId + '/remind/', { method: 'POST', headers: authHeaders() });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      alert('Reminded ' + j.reminded + ' people.');
    } catch (e) { alert(e.message); }
    setBusy(false);
  };

  return (
    <div>
      <button onClick={onBack} style={{ ...btn, marginBottom: 10 }}>Back</button>
      <div style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 10, padding: 14, marginBottom: 10 }}>
        <p style={{ margin: '0 0 3px', fontSize: 15, fontWeight: 700 }}>{d.rollcall.title}</p>
        <p style={{ margin: '0 0 9px', fontSize: 13, color: C.primary, fontWeight: 700 }}>
          {d.replied} of {d.expected} replied - {d.percent}%
        </p>
        <div style={{ background: C.surface, borderRadius: 5, height: 7, overflow: 'hidden' }}>
          <div style={{ width: d.percent + '%', height: '100%', background: C.primary }} />
        </div>
      </div>

      {d.summary.map(function (q) {
        return (
          <div key={q.id} style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 9, padding: '11px 13px', marginBottom: 8 }}>
            <p style={{ margin: '0 0 6px', fontSize: 13, fontWeight: 600 }}>{q.text}</p>
            <p style={{ margin: '0 0 6px', fontSize: 10.5, color: C.muted }}>{q.answered} answered</p>
            {q.breakdown ? q.breakdown.map(function (b) {
              const pct = q.answered ? Math.round(b.count * 100 / q.answered) : 0;
              return (
                <div key={b.value} style={{ marginBottom: 5 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
                    <span>{b.value}</span><b style={{ color: C.primary }}>{b.count}</b>
                  </div>
                  <div style={{ background: C.surface, borderRadius: 4, height: 5, overflow: 'hidden' }}>
                    <div style={{ width: pct + '%', height: '100%', background: C.primary }} />
                  </div>
                </div>
              );
            }) : (q.answers || []).map(function (a, i) {
              return <p key={i} style={{ margin: '3px 0', fontSize: 12, color: C.text, background: C.surface, borderRadius: 5, padding: '4px 8px' }}>{a}</p>;
            })}
          </div>
        );
      })}

      {d.missing_count > 0 ? (
        <div style={{ background: '#FDEDEC', border: '1px solid ' + C.danger, borderRadius: 9, padding: '11px 13px', marginBottom: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: C.danger }}>Did not reply ({d.missing_count})</p>
            {d.rollcall.status === 'open' ? (
              <button onClick={remind} disabled={busy} style={{ ...btn, color: C.danger, borderColor: C.danger, fontWeight: 700 }}>
                {busy ? 'Sending...' : 'Remind them'}
              </button>
            ) : null}
          </div>
          {d.missing.map(function (m) {
            return (
              <p key={m.id} style={{ margin: '4px 0 0', fontSize: 12, color: C.text }}>
                {m.name} <span style={{ color: C.muted }}>({m.level}{m.country ? ', ' + m.country : ''}) - last seen {m.last_active ? when(m.last_active) : 'never'}</span>
              </p>
            );
          })}
        </div>
      ) : null}

      <p style={{ fontSize: 12.5, fontWeight: 700, margin: '12px 0 7px' }}>Replies ({d.replies.length})</p>
      {d.replies.map(function (rp, i) {
        return (
          <div key={i} style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 9, padding: '10px 12px', marginBottom: 6 }}>
            <p style={{ margin: '0 0 5px', fontSize: 12.5, fontWeight: 600 }}>
              {rp.mod} <span style={{ fontSize: 10.5, color: C.muted, fontWeight: 400 }}>@{rp.username}{rp.country ? ' - ' + rp.country : ''} - {when(rp.at)}</span>
            </p>
            {d.questions.map(function (q) {
              const a = rp.answers[String(q.id)];
              if (!a || (Array.isArray(a) && !a.length)) return null;
              return (
                <p key={q.id} style={{ margin: '2px 0', fontSize: 11.5, color: C.muted }}>
                  {q.text} - <b style={{ color: C.text }}>{Array.isArray(a) ? a.join(', ') : String(a)}</b>
                </p>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

function CreateForm({ onDone, onBack }) {
  const [title, setTitle] = useState('');
  const [intro, setIntro] = useState('');
  const [forLevel, setForLevel] = useState('');
  const [qs, setQs] = useState([{ text: '', kind: 'text', options: '', required: true, hint: '' }]);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  const upd = function (i, k, v) { setQs(qs.map(function (q, x) { return x === i ? { ...q, [k]: v } : q; })); };
  const add = function () { setQs(qs.concat([{ text: '', kind: 'text', options: '', required: true, hint: '' }])); };
  const del = function (i) { setQs(qs.filter(function (_, x) { return x !== i; })); };

  const save = async function () {
    if (title.trim().length < 3) { setMsg('Give it a title.'); return; }
    const clean = qs.filter(function (q) { return q.text.trim(); });
    if (!clean.length) { setMsg('Add at least one question.'); return; }
    setBusy(true); setMsg('');
    try {
      const res = await fetch(API + '/rollcalls/create/', {
        method: 'POST', headers: authHeaders(),
        body: JSON.stringify({
          title: title, intro: intro, for_level: forLevel,
          questions: clean.map(function (q) {
            return {
              text: q.text, kind: q.kind, required: q.required, hint: q.hint,
              options: (q.kind === 'choice' || q.kind === 'multi')
                ? String(q.options || '').split(',').map(function (o) { return o.trim(); }).filter(Boolean) : [],
            };
          }),
        }),
      });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      onDone();
    } catch (e) { setMsg(e.message); }
    setBusy(false);
  };

  return (
    <div>
      <button onClick={onBack} style={{ ...btn, marginBottom: 10 }}>Back</button>
      <div style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 10, padding: 14 }}>
        <p style={{ margin: '0 0 3px', fontSize: 14.5, fontWeight: 700 }}>New roll call</p>
        <p style={{ margin: '0 0 11px', fontSize: 11.5, color: C.muted, lineHeight: 1.5 }}>
          Write your own questions - whatever you need to know this time.
        </p>

        <input value={title} onChange={function (e) { setTitle(e.target.value); }} placeholder="Title (e.g. August check-in)" style={inp} />
        <textarea value={intro} onChange={function (e) { setIntro(e.target.value); }} rows={2}
          placeholder="Anything the team should know before they answer (optional)" style={{ ...inp, resize: 'vertical' }} />
        <select value={forLevel} onChange={function (e) { setForLevel(e.target.value); }} style={inp}>
          <option value="">Everyone</option>
          <option value="mod">Only Moderators</option>
          <option value="mega">Only Mega Mods</option>
        </select>

        <p style={{ margin: '11px 0 7px', fontSize: 12.5, fontWeight: 700 }}>Questions</p>

        {qs.map(function (q, i) {
          return (
            <div key={i} style={{ background: C.surface, borderRadius: 8, padding: 10, marginBottom: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                <span style={{ fontSize: 11.5, fontWeight: 700, color: C.muted }}>Question {i + 1}</span>
                {qs.length > 1 ? (
                  <button onClick={function () { del(i); }} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 13, color: C.danger }}>remove</button>
                ) : null}
              </div>
              <input value={q.text} onChange={function (e) { upd(i, 'text', e.target.value); }} placeholder="What do you want to ask?" style={inp} />
              <div style={{ display: 'flex', gap: 7 }}>
                <select value={q.kind} onChange={function (e) { upd(i, 'kind', e.target.value); }} style={inp}>
                  {KINDS.map(function (k) { return <option key={k[0]} value={k[0]}>{k[1]}</option>; })}
                </select>
                <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 11.5, color: C.muted, whiteSpace: 'nowrap', marginBottom: 8 }}>
                  <input type="checkbox" checked={q.required} onChange={function (e) { upd(i, 'required', e.target.checked); }} />
                  required
                </label>
              </div>
              {(q.kind === 'choice' || q.kind === 'multi') ? (
                <input value={q.options || ''} onChange={function (e) { upd(i, 'options', e.target.value); }} placeholder="Options, separated by commas" style={inp} />
              ) : null}
            </div>
          );
        })}

        <button onClick={add} style={{ ...btn, marginBottom: 11 }}>+ Add question</button>
        {msg ? <p style={{ fontSize: 12.5, color: C.danger, margin: '0 0 9px' }}>{msg}</p> : null}
        <div style={{ display: 'flex', gap: 7 }}>
          <button onClick={save} disabled={busy} style={btnMain}>{busy ? 'Saving...' : 'Save as draft'}</button>
          <button onClick={onBack} style={btn}>Cancel</button>
        </div>
        <p style={{ margin: '8px 0 0', fontSize: 11, color: C.muted }}>
          It saves as a draft - nobody sees it until you press Open.
        </p>
      </div>
    </div>
  );
}

export default function RollCallsTab() {
  const [d, setD] = useState(null);
  const [view, setView] = useState('list');
  const [pick, setPick] = useState(null);

  const load = useCallback(function () {
    fetch(API + '/rollcalls/', { headers: authHeaders() })
      .then(function (r) { return r.json(); }).then(setD).catch(function () {});
  }, []);
  useEffect(function () { if (view === 'list') load(); }, [view, load]);

  if (view === 'create') return <CreateForm onBack={function () { setView('list'); }} onDone={function () { setView('list'); }} />;
  if (view === 'reply') return <ReplyForm rcId={pick} onBack={function () { setView('list'); }} onDone={function () { setView('list'); }} />;
  if (view === 'report') return <Report rcId={pick} onBack={function () { setView('list'); }} />;

  if (!d) return <p style={{ color: C.muted, textAlign: 'center', padding: '2rem 0' }}>Loading...</p>;
  if (d.error) return <p style={{ color: C.danger, textAlign: 'center', padding: '2rem 0' }}>{d.error}</p>;

  const act = async function (rc, action) {
    if (action === 'open' && !window.confirm('Open "' + rc.title + '"? Everyone it applies to will be notified right away.')) return;
    if (action === 'delete' && !window.confirm('Delete this draft?')) return;
    try {
      const res = await fetch(API + '/rollcalls/' + rc.id + '/action/', {
        method: 'POST', headers: authHeaders(), body: JSON.stringify({ action: action }) });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error);
      if (action === 'open') alert('Opened - ' + j.notified + ' people notified.');
      load();
    } catch (e) { alert(e.message); }
  };

  return (
    <>
      {d.can_manage ? <button onClick={function () { setView('create'); }} style={{ ...btnMain, marginBottom: 11 }}>+ New roll call</button> : null}

      {d.rollcalls.length === 0 ? (
        <p style={{ textAlign: 'center', color: C.muted, fontSize: 12.5, padding: '2rem 1rem' }}>No roll calls yet.</p>
      ) : d.rollcalls.map(function (r) {
        const colr = r.status === 'open' ? C.primary : r.status === 'draft' ? C.gold : C.muted;
        return (
          <div key={r.id} style={{ background: '#fff', border: '1px solid ' + C.border, borderRadius: 9, padding: '11px 13px', marginBottom: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 13.5, fontWeight: 600 }}>{r.title}</span>
              <span style={{ fontSize: 10.5, fontWeight: 700, color: colr, textTransform: 'uppercase' }}>{r.status}</span>
            </div>
            <p style={{ margin: '3px 0 0', fontSize: 11.5, color: C.muted }}>
              {r.replies} replied
              {r.for_level ? ' - ' + (r.for_level === 'mega' ? 'Mega Mods only' : 'Mods only') : ''}
              {r.created_by ? ' - by ' + r.created_by : ''} - {when(r.created_at)}
            </p>
            <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginTop: 8 }}>
              {r.status === 'open' && !r.i_replied ? (
                <button style={btnMain} onClick={function () { setPick(r.id); setView('reply'); }}>Reply now</button>
              ) : null}
              {r.i_replied ? <span style={{ fontSize: 11.5, color: C.primary, fontWeight: 600, alignSelf: 'center' }}>You replied</span> : null}
              {d.can_manage ? (
                <>
                  <button style={btn} onClick={function () { setPick(r.id); setView('report'); }}>Report</button>
                  {r.status === 'draft' ? (
                    <>
                      <button style={{ ...btn, color: C.primary, borderColor: C.primary, fontWeight: 700 }} onClick={function () { act(r, 'open'); }}>Open</button>
                      <button style={{ ...btn, color: C.danger, borderColor: C.danger }} onClick={function () { act(r, 'delete'); }}>Delete</button>
                    </>
                  ) : null}
                  {r.status === 'open' ? <button style={btn} onClick={function () { act(r, 'close'); }}>Close</button> : null}
                </>
              ) : null}
            </div>
          </div>
        );
      })}
    </>
  );
}
